/**
 * Moxi Main Cart - Gestión dinámica del botón de checkout en página de carrito
 * Detecta productos de suscripción y actualiza el botón automáticamente
 */

(function() {
  'use strict';
    
  const CONFIG = {
    checkInterval: 2000, 
    clickDelay: 100,
    buttonContainerId: 'main-cart-checkout-button'
  };
  
  async function getCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('No se pudo leer el carrito');
      return res.json();
    } catch (error) {
      console.error('[MoxiMainCart] Error obteniendo carrito:', error);
      return null;
    }
  }

  async function clearSubscriptionProperties() {
    try {
      console.log('[MoxiMainCart] Limpiando propiedades de suscripción...');
      
      // Primero, prevenir que se regeneren los campos de suscripción
      preventSubscriptionFieldsGeneration();
      
      const cart = await getCart();
      if (!cart || !cart.items) {
        console.log('[MoxiMainCart] No hay items en el carrito');
        return;
      }

      // Procesar cada item individualmente
      for (const item of cart.items) {
        if (item.properties) {
          const hasSubscriptionProps = Object.keys(item.properties).some(key => 
            key.startsWith('_subscription_')
          );
          
          if (hasSubscriptionProps) {
            console.log('[MoxiMainCart] Limpiando propiedades de suscripción del item:', item.title);
            console.log('[MoxiMainCart] Propiedades actuales:', item.properties);
            
            // Crear objeto de propiedades limpias (sin las de suscripción)
            const cleanProperties = {};
            Object.keys(item.properties).forEach(key => {
              if (!key.startsWith('_subscription_')) {
                cleanProperties[key] = item.properties[key];
              }
            });
            
            console.log('[MoxiMainCart] Propiedades limpias:', cleanProperties);
            
            // Método 1: Intentar con properties vacío si no hay otras propiedades
            let updateData;
            if (Object.keys(cleanProperties).length === 0) {
              // Si no hay otras propiedades, enviar properties como null para eliminarlas
              updateData = {
                id: item.key,
                properties: null
              };
            } else {
              // Si hay otras propiedades, enviar solo las limpias
              updateData = {
                id: item.key,
                properties: cleanProperties
              };
            }
            
            console.log('[MoxiMainCart] Actualizando item:', updateData);
            
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ updates: [updateData] })
            });

            if (response.ok) {
              const updatedCart = await response.json();
              console.log('[MoxiMainCart] Item actualizado exitosamente');
              console.log('[MoxiMainCart] Carrito después de actualizar:', updatedCart);
              
              // Verificar si las propiedades se limpiaron
              const updatedItem = updatedCart.items.find(updatedItem => updatedItem.key === item.key);
              if (updatedItem && updatedItem.properties) {
                console.log('[MoxiMainCart] Propiedades después de actualizar:', updatedItem.properties);
              }
            } else {
              const errorText = await response.text();
              console.error('[MoxiMainCart] Error actualizando item:', errorText);
              
              // Método alternativo: Intentar eliminar propiedades específicas
              console.log('[MoxiMainCart] Intentando método alternativo...');
              await clearPropertiesAlternative(item);
            }
          }
        }
      }
      
      // Disparar evento para actualizar la UI
      document.dispatchEvent(new CustomEvent('cart:updated'));
      console.log('[MoxiMainCart] Proceso de limpieza completado');

    } catch (error) {
      console.error('[MoxiMainCart] Error en clearSubscriptionProperties:', error);
    }
  }

  function preventSubscriptionFieldsGeneration() {
    console.log('[MoxiMainCart] Previniendo generación de campos de suscripción...');
    
    // Marcar que hay un cupón activo para prevenir la generación de campos
    window.hasActiveCoupon = true;
    
    // Interceptar la función showTabContent si existe
    if (typeof window.showTabContent === 'function') {
      const originalShowTabContent = window.showTabContent;
      window.showTabContent = function(event, tabId, discountApplied, attributeName) {
        console.log('[MoxiMainCart] showTabContent interceptada, tabId:', tabId);
        
        // Si hay cupón activo y es tab2 (suscripción), no generar campos de suscripción
        if (window.hasActiveCoupon && tabId === 'tab2') {
          console.log('[MoxiMainCart] Cupón activo detectado, evitando generación de campos de suscripción');
          
          // Ocultar todo el contenido de las pestañas
          var contents = document.querySelectorAll('.tab-content');
          contents.forEach(function(content) {
            content.classList.remove('active');
          });

          // Quitar la clase 'active' de todas las pestañas
          var tabs = document.querySelectorAll('.tab');
          tabs.forEach(function(tab) {
            tab.classList.remove('active');
            tab.classList.add('inactive');
          });

          // Mostrar el contenido seleccionado y marcar la pestaña activa
          document.getElementById(tabId).classList.add('active');
          event.currentTarget.classList.add('active');
          event.currentTarget.classList.remove('inactive');

          // NO generar campos de suscripción
          var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field');
          if (lineItemField) {
            lineItemField.innerHTML = `
              <input type="hidden" name="properties[Compra Unica]" value="true">
            `;
          }
          
          return; // Salir sin ejecutar la lógica original
        }
        
        // Si no hay cupón activo, ejecutar la función original
        return originalShowTabContent.call(this, event, tabId, discountApplied, attributeName);
      };
    }
  }

  async function clearPropertiesAlternative(item) {
    try {
      console.log('[MoxiMainCart] Método alternativo: Eliminando propiedades específicas');
      
      // Crear un objeto con las propiedades de suscripción como null
      const propertiesToClear = {};
      Object.keys(item.properties).forEach(key => {
        if (key.startsWith('_subscription_')) {
          propertiesToClear[key] = null;
        } else {
          propertiesToClear[key] = item.properties[key];
        }
      });
      
      console.log('[MoxiMainCart] Propiedades a limpiar:', propertiesToClear);
      
      const updateData = {
        id: item.key,
        properties: propertiesToClear
      };
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: [updateData] })
      });

      if (response.ok) {
        const updatedCart = await response.json();
        console.log('[MoxiMainCart] Método alternativo exitoso');
        console.log('[MoxiMainCart] Carrito actualizado:', updatedCart);
      } else {
        const errorText = await response.text();
        console.error('[MoxiMainCart] Error en método alternativo:', errorText);
      }
      
    } catch (error) {
      console.error('[MoxiMainCart] Error en clearPropertiesAlternative:', error);
    }
  }
  
  async function checkSubscriptionsWithAPI() {
    
    const cart = await getCart();
    if (!cart) {
      return false;
    }
    
    // Verificar si hay cupón de descuento activo (no descuentos de suscripción)
    const hasActiveCoupon = (cart.discount_codes && cart.discount_codes.length > 0) ||
                           (cart.attributes && cart.attributes.discount_code) ||
                           (cart.attributes && cart.attributes.coupon_code);
    
    // Verificar si hay productos con suscripción
    let hasSubscription = false;
    let subscriptionItemsWithCouponDiscount = [];
    let subscriptionItemsWithoutCouponDiscount = [];
    
    cart.items.forEach((item, index) => {   
      if (item.properties && item.properties._subscription_price) {
        hasSubscription = true;
        console.log('[MoxiMainCart] Suscripción detectada en item:', item.title);
        
        // Verificar si este producto con suscripción tiene descuento de cupón aplicado
        const hasCouponDiscount = item.line_level_discount_allocations && 
          item.line_level_discount_allocations.length > 0;
        
        if (hasCouponDiscount) {
          subscriptionItemsWithCouponDiscount.push({
            title: item.title,
            key: item.key,
            discounts: item.line_level_discount_allocations
          });
          console.log('[MoxiMainCart] Producto con suscripción tiene descuento de cupón:', item.title);
        } else {
          subscriptionItemsWithoutCouponDiscount.push({
            title: item.title,
            key: item.key
          });
          console.log('[MoxiMainCart] Producto con suscripción SIN descuento de cupón:', item.title);
        }
      }
    });
    
    // Si hay cupón activo Y productos con suscripción
    if (hasActiveCoupon && hasSubscription) {
      console.log('[MoxiMainCart] Cupón activo y productos con suscripción detectados:', {
        discount_codes: cart.discount_codes,
        discount_code: cart.attributes?.discount_code,
        coupon_code: cart.attributes?.coupon_code,
        total_discount: cart.total_discount,
        subscriptionItemsWithCouponDiscount: subscriptionItemsWithCouponDiscount.length,
        subscriptionItemsWithoutCouponDiscount: subscriptionItemsWithoutCouponDiscount.length
      });
      
      // Siempre mostrar "continuar con la compra" si hay suscripción, sin limpiar propiedades
      console.log('[MoxiMainCart] Hay suscripción, mostrando "continuar con la compra" sin limpiar propiedades.');
      window.hasActiveCoupon = false; // Permitir suscripciones
      return true; // true = hay suscripción = mostrar "continuar con la compra"
    } else if (hasActiveCoupon && !hasSubscription) {
      // Si hay cupón pero NO hay productos con suscripción, comportamiento normal
      console.log('[MoxiMainCart] Cupón activo pero sin productos con suscripción');
      window.hasActiveCoupon = true;
      return false; // false = no suscripción = mostrar "Finalizar compra"
    } else {
      // Si no hay cupón activo, permitir generación de campos de suscripción
      window.hasActiveCoupon = false;
    }
    
    console.log('[MoxiMainCart] Estado del carrito:', {
      hasSubscription,
      hasActiveCoupon,
      subscriptionItemsWithCouponDiscount: subscriptionItemsWithCouponDiscount.length,
      subscriptionItemsWithoutCouponDiscount: subscriptionItemsWithoutCouponDiscount.length,
      discount_codes: cart.discount_codes,
      total_discount: cart.total_discount,
      items_count: cart.items.length
    });
    
    return hasSubscription;
  }

  /**
   * Agrega etiquetas de suscripción a los productos con suscripción en el carrito principal
   */
  async function addSubscriptionTagsToMainCart() {
    try {
      const cart = await getCart();
      if (!cart || !cart.items) {
        return;
      }

      // Obtener todos los items del carrito principal
      const cartItems = document.querySelectorAll('[data-cart-item]');
      
      // Primero, remover todas las etiquetas existentes para evitar duplicados
      cartItems.forEach(item => {
        const existingTag = item.querySelector('.moxi-subscription-tag');
        if (existingTag) {
          existingTag.remove();
        }
      });

      // Identificar items con suscripción y agregar etiquetas
      cart.items.forEach(cartItem => {
        const hasSubscription = cartItem.properties && cartItem.properties._subscription_price;
        
        if (hasSubscription) {
          // Buscar el elemento del DOM correspondiente a este item del carrito
          // En el carrito principal, los items tienen data-cart-item pero no data-pid
          // Necesitamos buscar por el key del item o por el título
          const domItem = Array.from(cartItems).find(item => {
            // Buscar por el título del producto
            const titleLink = item.querySelector('.t4s-page_cart__title');
            if (titleLink && titleLink.textContent.trim() === cartItem.title.trim()) {
              return true;
            }
            return false;
          });

          if (domItem) {
            // Verificar si ya tiene la etiqueta
            if (!domItem.querySelector('.moxi-subscription-tag')) {
              // Buscar el contenedor del título (el <a>)
              const titleLink = domItem.querySelector('.t4s-page_cart__title');
              if (titleLink) {
                // Crear la etiqueta
                const tag = document.createElement('span');
                tag.className = 'moxi-subscription-tag';
                tag.textContent = 'Suscripción';
                tag.style.cssText = `
                  display: inline-block;
                  background-color: #111111;
                  color: #ffffff;
                  font-size: 10px;
                  font-weight: 600;
                  text-transform: uppercase;
                  padding: 2px 6px;
                  border-radius: 3px;
                  margin-left: 8px;
                  vertical-align: middle;
                  letter-spacing: 0.5px;
                `;
                
                // Insertar después del enlace del título, dentro del mismo contenedor padre
                if (titleLink.nextSibling) {
                  titleLink.parentNode.insertBefore(tag, titleLink.nextSibling);
                } else {
                  titleLink.parentNode.appendChild(tag);
                }
                console.log('[MoxiMainCart] Etiqueta de suscripción agregada al producto:', cartItem.title);
              }
            }
          }
        }
      });
    } catch (error) {
      console.error('[MoxiMainCart] Error agregando etiquetas de suscripción:', error);
    }
  }

  function generateButtonHTML(hasSubscription, buttonStyle, buttonSize, buttonColor, buttonEffect, ckLumise, btnIcon) {
    const iconHTML = btnIcon ? '<svg xmlns="http://www.w3.org/2000/svg" class="t4s-btn-icon" viewBox="0 0 640 512"><path d="M96 0C107.5 0 117.4 8.19 119.6 19.51L121.1 32H541.8C562.1 32 578.3 52.25 572.6 72.66L537.6 196.9C524.3 193.7 510.3 192 496 192C493.7 192 491.4 192 489.1 192.1L520.6 80H131.1L161.6 240H375.2C360.6 253.8 348.4 269.1 339.2 288H170.7L179.9 336H322.9C320.1 346.4 319.1 357.1 319.1 368C319.1 373.4 320.2 378.7 320.7 384H159.1C148.5 384 138.6 375.8 136.4 364.5L76.14 48H24C10.75 48 0 37.26 0 24C0 10.75 10.75 .0003 24 .0003L96 0zM128 464C128 437.5 149.5 416 176 416C202.5 416 224 437.5 224 464C224 490.5 202.5 512 176 512C149.5 512 128 490.5 128 464zM640 368C640 447.5 575.5 512 496 512C416.5 512 352 447.5 352 368C352 288.5 416.5 224 496 224C575.5 224 640 288.5 640 368zM480 385.4L451.3 356.7C445.1 350.4 434.9 350.4 428.7 356.7C422.4 362.9 422.4 373.1 428.7 379.3L468.7 419.3C474.9 425.6 485.1 425.6 491.3 419.3L563.3 347.3C569.6 341.1 569.6 330.9 563.3 324.7C557.1 318.4 546.9 318.4 540.7 324.7L480 385.4z"></path></svg>' : '';
    
    if (hasSubscription) {
      return `
        <a href="/pages/tokenizacion" class="t4s-btn__checkout t4s-btn t4s-btn-base t4s-btn-style-${buttonStyle} t4s-btn-size-${buttonSize} t4s-btn-color-${buttonColor} {% if buttonStyle == 'default' or buttonStyle == 'outline' %}t4s-btn-effect-${buttonEffect}{% endif %} t4s-w-100 t4s-justify-content-center t4s-truncate">
          ${iconHTML}continuar con la compra
        </a>
      `;
    } else {
      return `
        <button type="submit" data-loading-bar data-confirm="${ckLumise}" name="checkout" class="t4s-btn__checkout t4s-btn t4s-btn-base t4s-btn-style-${buttonStyle} t4s-btn-size-${buttonSize} t4s-btn-color-${buttonColor} {% if buttonStyle == 'default' or buttonStyle == 'outline' %}t4s-btn-effect-${buttonEffect}{% endif %} t4s-w-100 t4s-justify-content-center t4s-truncate">
          ${iconHTML}Finalizar compra
        </button>
      `;
    }
  }
  
  async function updateButtonWithAPI() {
    const buttonContainer = document.getElementById(CONFIG.buttonContainerId);
    if (!buttonContainer) {
      return;
    }
    
    const hasSubscription = await checkSubscriptionsWithAPI();
    const buttonStyle = buttonContainer.dataset.buttonStyle || 'default';
    const buttonSize = buttonContainer.dataset.buttonSize || 'large';
    const buttonColor = buttonContainer.dataset.buttonColor || 'dark';
    const buttonEffect = buttonContainer.dataset.buttonEffect || 'default';
    const ckLumise = buttonContainer.dataset.ckLumise || '';
    const btnIcon = buttonContainer.dataset.btnIcon === 'true';
    
    const buttonHTML = generateButtonHTML(hasSubscription, buttonStyle, buttonSize, buttonColor, buttonEffect, ckLumise, btnIcon);
    buttonContainer.innerHTML = buttonHTML;
    
    const buttonText = hasSubscription ? 'continuar con la compra' : 'Finalizar compra';
    
    // Agregar etiquetas de suscripción a los productos
    await addSubscriptionTagsToMainCart();
  }
  
  function initialize() {
    
    updateButtonWithAPI();
    
    setInterval(updateButtonWithAPI, CONFIG.checkInterval);
    
    document.addEventListener('click', function() {
      setTimeout(updateButtonWithAPI, CONFIG.clickDelay);
    });
    
    document.addEventListener('cart:updated', updateButtonWithAPI);
    document.addEventListener('cart:item-added', updateButtonWithAPI);
    document.addEventListener('cart:item-removed', updateButtonWithAPI);
    
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name*="updates"]') || e.target.matches('select[name*="updates"]')) {
        setTimeout(updateButtonWithAPI, CONFIG.clickDelay);
      }
    });
    
    // Observar cambios en el DOM del carrito principal para agregar etiquetas cuando se actualiza
    const observer = new MutationObserver(function(mutations) {
      const cartItems = document.querySelectorAll('[data-cart-item]');
      if (cartItems.length > 0) {
        // Esperar un poco para que el DOM se actualice completamente
        setTimeout(() => {
          addSubscriptionTagsToMainCart();
        }, 300);
      }
    });
    
    // Observar el contenedor del carrito principal
    const mainCartContainer = document.querySelector('.t4s-cartPage__items');
    if (mainCartContainer) {
      observer.observe(mainCartContainer, {
        childList: true,
        subtree: true
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  window.MoxiMainCart = {
    getCart,
    checkSubscriptionsWithAPI,
    updateButtonWithAPI,
    clearSubscriptionProperties,
    preventSubscriptionFieldsGeneration,
    clearPropertiesAlternative,
    addSubscriptionTagsToMainCart,
    CONFIG
  };
  
})();
